// Timezone-aware date/time formatting. The org's timezone is chosen in
// Settings → General and applied across the app (call history, reports).

export function browserTimezone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch {
        return "UTC";
    }
}

export function formatDateTime(iso, tz) {
    if (!iso) return "—";
    try {
        return new Intl.DateTimeFormat(undefined, {
            dateStyle: "medium",
            timeStyle: "short",
            timeZone: tz || browserTimezone(),
        }).format(new Date(iso));
    } catch {
        try { return new Date(iso).toLocaleString(); } catch { return iso; }
    }
}

export function formatDate(iso, tz) {
    if (!iso) return "—";
    try {
        return new Intl.DateTimeFormat(undefined, {
            dateStyle: "medium",
            timeZone: tz || browserTimezone(),
        }).format(new Date(iso));
    } catch { return ""; }
}

export function formatTime(iso, tz) {
    if (!iso) return "";
    try {
        return new Intl.DateTimeFormat(undefined, {
            timeStyle: "short",
            timeZone: tz || browserTimezone(),
        }).format(new Date(iso));
    } catch { return ""; }
}

const FALLBACK_ZONES = [
    "UTC", "America/New_York", "America/Chicago", "America/Denver", "America/Los_Angeles",
    "America/Sao_Paulo", "Europe/London", "Europe/Paris", "Europe/Berlin", "Europe/Moscow",
    "Africa/Johannesburg", "Asia/Dubai", "Asia/Kolkata", "Asia/Singapore", "Asia/Hong_Kong",
    "Asia/Tokyo", "Australia/Sydney", "Pacific/Auckland",
];

export function timezoneList() {
    try {
        if (typeof Intl.supportedValuesOf === "function") {
            const list = Intl.supportedValuesOf("timeZone");
            if (list && list.length) return list;
        }
    } catch { /* ignore */ }
    return FALLBACK_ZONES;
}
